import Vue from 'vue'
import VueRouter from  'vue-router'
import App from '@/App'

Vue.use(VueRouter);

const routes = [
  {
    path: "/:confid/:sessionid/:key",
    props: true,
    name: "home",
    component: App
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.environment === 'development' ? '/' : process.env.VUE_APP_HTMLDIR+'/',
  routes
})

export default router